import FileDownloadApi from './FileDownloadApi';
import HttpService from './HttpService';

const DailyReportsApi = HttpService('/api/dailyreports/');
const doGet = (url) => DailyReportsApi.get(url);

export default {
  getDailyVoyageReport(activeSiteId, date) {
    const apiAction = 'GetDailyVoyageReport';
    const queryString = `activeSiteId=${activeSiteId}&date=${date}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  getDailyTankReport(activeSiteId, date) {
    const apiAction = 'GetDailyTankReport';
    const queryString = `activeSiteId=${activeSiteId}&date=${date}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  getDailyVoyageReportAsExcel(activeSiteId, date) {
    const fullUrl = `dailyreports/GetDailyVoyageReportExcelExport?activeSiteId=${activeSiteId}&date=${date}`;
    return FileDownloadApi().get(fullUrl);
  },
  getDailyTankReportAsExcel(activeSiteId, date) {
    const fullUrl = `dailyreports/GetDailyTankReportExcelExport?activeSiteId=${activeSiteId}&date=${date}`;
    return FileDownloadApi().get(fullUrl);
  },
};
